import Resolution from "engine/Resolution.js";
import {uuid} from 'uuidv4';
import {setSelectedPianoRollSteps} from 'actions/index.js';

// ASSUMES resolution=1/32n
const RESOLUTION = new Resolution(32, false);

export const chop = (track, steps, stepNumber, duration, chop) => {
    chop = Math.min(Math.max(1, chop), 32);

    // first delete steps
    let stepData = steps[0].getCopy(true, false);
    let pattern = track.getEasyPattern();
    pattern.deleteSteps(steps);

    // then add them agagin usingg the chop
    let choppedSteps = [];
    let chopDuration= duration / chop;
    let newSteps = [];
    for (let i=0; i < chop; i++) {
        let _stepNumber = stepNumber + 2 * i * duration / chop;
        let position = _stepNumber - Math.floor(_stepNumber);
        let _stepData = stepData.getCopy(true, false, undefined, undefined, false, false);
        _stepData.id = uuid();
        _stepData.duration = chopDuration;
        pattern.addStep(
            _stepData,
            Math.floor(_stepNumber),
            RESOLUTION,
            position);
        newSteps.push(_stepData);
    }

    track.updateSteps(true);

    track.sequencerEngine.dispatch(
        setSelectedPianoRollSteps(newSteps));
    // return the newly added steps
    return newSteps;
};
